import CmsManage from './index';
import Preview from './column/preview';
import Article from './content/article';
import News from './content/news';
import ArticleSimplify from './content/articleSimplify';
import NewsSimplify from './content/newsSimplify';
import Character from './label/character';
import Custom from './label/custom';
import Mechanism from './label/mechanism';
import Product from './label/product';
import Project from './label/project';
import Category from './label/category';
import RecommendItem from './recommend/recommendItem';
import RecommendPosition from './recommend/recommendPosition';
import RelevantRecommend from './recommend/relevantRecommend';
import AllTask from './review/allTask';
import Wait from './review/wait';
import NewsDetail from './review/detail/newsDetail';
import StatisticsNews from './statistics/statisticsNews';
import Message from './message/message';

export default {
    path: 'cms/manage/',
    component: CmsManage,
    children: [
        {path: '/cms/manage/column/preview', component: Preview},
        {path: '/cms/manage/content/article', component: Article},
        {path: '/cms/manage/content/news', component: News},
        {path: '/cms/manage/content/articleSimplify', component: ArticleSimplify},
        {path: '/cms/manage/content/newsSimplify', component: NewsSimplify},
        {path: '/cms/manage/label/character', component: Character},
        {path: '/cms/manage/label/custom', component: Custom},
        {path: '/cms/manage/label/mechanism', component: Mechanism},
        {path: '/cms/manage/label/product', component: Product},
        {path: '/cms/manage/label/project', component: Project},
        {path: '/cms/manage/label/category', component: Category},
        {path: '/cms/manage/recommend/recommendItem', component: RecommendItem},
        {path: '/cms/manage/recommend/recommendPosition', component: RecommendPosition},
        {path: '/cms/manage/recommend/relevantRecommend', component: RelevantRecommend},
        {path: '/cms/manage/review/allTask', component: AllTask},
        {path: '/cms/manage/review/wait', component: Wait},
        {path: '/cms/manage/review/detail/newsDetail', component: NewsDetail},
        {path: '/cms/manage/statistics/statisticsNews', component: StatisticsNews},
        {path: '/cms/manage/message', component: Message},
    ]
}
